import { IApplicationState } from '../../types/redux';
import { IPlaceholderImage } from '../../types/aerialView';
import { PLACEHOLDERS } from '../../constants/aerialView';

export function getAerialViewPlaceholders(state: IApplicationState): IPlaceholderImage[] {
  const { aerialView } = state;

  return aerialView.placeholders || PLACEHOLDERS;
}
